// Requetes GET dynamiques : on contourne le cache HTTP du navigateur, y compris
// une entree perimee deja presente (ex. index.html servi par erreur).
// - `_=<timestamp>` change l'URL -> ignore les entrees existantes ;
// - `Cache-Control: no-cache` force la revalidation.
export function noCacheUrl(url) {
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}_=${Date.now()}`;
}

export const noCacheConfig = {
  headers: { "Cache-Control": "no-cache" },
};

export function getNoCache(client, url, config = {}) {
  return client.get(noCacheUrl(url), {
    ...config,
    headers: { ...noCacheConfig.headers, ...(config.headers || {}) },
  });
}
